// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NE5Ep","scaleLoop":"styles_scaleLoop__tvFjB","overlay":"styles_overlay__Ea4aM"};